import { BaseSendMessageModel } from "./MessageModel";

export enum AdSpaceEnum {
    Notification = 1,
    Explore = 2,
    Tenders = 3,
    Carousel = 4,
    Jobs = 5,
    Stories = 6,
    PinnedToTop = 7
}

export interface AdsPricingResponse {
    Id: AdSpaceEnum;
    AdSpace: string;
    Price: number;
    Name: string;
    ImageId: string;
    ImpressionsPerWeek: number;
    PosterPrice: number;
}

export class AdsPricing {
    Id: AdSpaceEnum;
    AdSpace: string;
    Price: number;
    Name: string;
    ImageId: string;
    ImpressionsPerWeek: number;
    PosterPrice: number;
    constructor(fromServer: AdsPricingResponse = null) {
        if (fromServer != null) {
            this.Id = fromServer.Id;
            this.AdSpace = fromServer.AdSpace;
            this.Price = fromServer.Price;
            this.Name = fromServer.Name;
            this.ImageId = fromServer.ImageId;
            this.ImpressionsPerWeek = fromServer.ImpressionsPerWeek;
            this.PosterPrice = fromServer.PosterPrice;
        }
    }
}

export interface Advert {
    Id: number;
    Title: string;
    Link: string;
    IsLive: boolean;
    BannerId: any;
    DateCreatedUtc: string;
    DateUpdatedUtc: string;
    CreatedByUserId: string;
    Email: string;
    PinToTop: boolean;
    GooglePlayLink: string;
    AppStoreLink: string;
    AdvertTypeId: AdvertTypeEnum;
    AdvertType: string;
    DateOfEvent: Date; 
    ShowInFeed: boolean;
    AdSpace: AdSpaceEnum;
}

export interface AdvertOrderResponse {
    OrderId: number;
    UserId: string;
    UserName: string;
    AdSpace: number;
    AdSpaceEnum: string;
    NumberOfAds: number;
    ImpressionCost: number;
    EstimatedImpressions: number;
    ImpressionsCount: number | null;
    ClicksCount: number | null;
    DurationInDays: number | null;
    StartDateUtc: Date;
    EndDateUtc: Date;
    DateCreatedUtc: Date;
    Adverts: Advert[];
    TotalCost: number | null;
    IsLive: boolean;
    IsPaidFor: boolean;
    IsLiveStatus: string;
    Interactions: Interaction[];
}


export class AdvertOrder {
    OrderId: number;
    UserId: string;
    UserName: string;
    AdSpace: number;
    NumberOfAds: number;
    ImpressionCost: number;
    EstimatedImpressions: number;
    TotalCost?: number;
    DurationInDays?: number;
    ImpressionsCount?: number;
    ClicksCount?: number;
    StartDateUtc: Date;
    EndDateUtc: Date;
    DateCreatedUtc: Date;
    Adverts: Advert[] = [];
    IsLive: boolean | null;
    IsPaidFor: boolean;
    IsLiveStatus: string;
    Interactions: Interaction[];
    

    constructor(fromServer: AdvertOrderResponse = null) {
        if (fromServer !== null) {
            this.OrderId = fromServer.OrderId;
            this.UserId = fromServer.UserId;
            this.UserName = fromServer.UserName;
            this.AdSpace = fromServer.AdSpace;
            this.NumberOfAds = fromServer.NumberOfAds;
            this.ImpressionCost = fromServer.ImpressionCost;
            this.TotalCost = fromServer.TotalCost;
            this.DurationInDays = fromServer.DurationInDays;
            this.EstimatedImpressions = fromServer.EstimatedImpressions;
            this.ImpressionsCount = fromServer.ImpressionsCount;
            this.ClicksCount = fromServer.ClicksCount;
            this.StartDateUtc = new Date(fromServer.StartDateUtc);
            this.EndDateUtc = new Date(fromServer.EndDateUtc);
            this.DateCreatedUtc = new Date(fromServer.DateCreatedUtc);
            this.Adverts = fromServer.Adverts;
            this.IsLive= fromServer.IsLive;
            this.IsPaidFor = fromServer.IsPaidFor;
            this.IsLiveStatus = fromServer.IsLiveStatus;
            this.Interactions = fromServer.Interactions;
        }
    }
}

export class CreateAdvertModel extends BaseSendMessageModel{
    title: string;
    link: string;
    bannerId: any;
    email: string;
	pinToTop: boolean;
    googlePlayLink: string;
    appStoreLink: string;
    advertTypeId: AdvertTypeEnum;
    dateOfEvent: Date;
    showInFeed: boolean;
    adSpace: AdSpaceEnum;
    isLive: boolean;
    constructor() {
        super();
        this.advertTypeId = AdvertTypeEnum.Ads;
        this.showInFeed = true;
        this.isLive = true;
    }
}

export class EditAdvertOrderModel {
    OrderId: number;
    UserId: string;
    UserName: string;
    AdSpace: number;
    NumberOfAds: number;
    ImpressionCost: number;
    EstimatedImpressions: number;
    StartDateUtc?: Date;
    DurationInDays: number;
    Adverts?: Advert[];
    TotalCost?: number;
    IsLive: boolean;
    IsPaidFor: boolean;
    IsLiveStatus: string;

    constructor(AdvertOrder: AdvertOrder = null) {
        if (AdvertOrder !== null) {
            this.OrderId = AdvertOrder.OrderId;
            this.UserId = AdvertOrder.UserId;
            this.UserName = AdvertOrder.UserName;
            this.AdSpace = AdvertOrder.AdSpace;
            this.NumberOfAds = AdvertOrder.NumberOfAds;
            this.ImpressionCost = AdvertOrder.ImpressionCost;
            this.EstimatedImpressions = AdvertOrder.EstimatedImpressions;
            this.StartDateUtc = new Date(AdvertOrder.StartDateUtc);
            this.DurationInDays = AdvertOrder.DurationInDays;
            this.Adverts = AdvertOrder.Adverts;
            this.TotalCost = AdvertOrder.TotalCost;
            this.IsLive = AdvertOrder.IsLive;
            this.IsPaidFor = AdvertOrder.IsPaidFor;
            this.IsLiveStatus = AdvertOrder.IsLiveStatus;
        }
    }
}

export class EditAdvertModel extends CreateAdvertModel {
	id: number;
	constructor(item?: Advert) {
		super();
		this.id = item && item.Id;
        this.title = item && item.Title;
        this.link = item && item.Link;
        this.bannerId = item && item.BannerId;
        this.email = item && item.Email;
        this.googlePlayLink = item && item.GooglePlayLink;
        this.appStoreLink = item && item.AppStoreLink;
        this.advertTypeId = item && item.AdvertTypeId;
        this.dateOfEvent = item && item.DateOfEvent;
        this.pinToTop = item && item.PinToTop;
        this.isLive = item && item.IsLive;
        this.adSpace = item && (item.AdSpace != null ? item.AdSpace : AdSpaceEnum.Notification);
    }
}

export enum AdvertTypeEnum
{
    Ads = 1,
    Events = 2,
    Apps = 3,
    Campaigns = 4,
    Content = 5
}

export enum InteractionsTypeEnum
{
    Impression = 1,
    Click = 2,
    ClickRate = 3,
    Share = 4
}

export interface InteractionResponse
{
    Id: Number;
    Type: string;
    Value: string | null;
    DateCreatedUtc: Date;
}

export class Interaction
{
    Id: Number;
    Type: string;
    Value: string | null;
    DateCreatedUtc: Date;
    constructor(fromServer: InteractionResponse = null) {
        if (fromServer !== null) {
            this.Id = fromServer.Id;
            this.Type = fromServer.Type;
            this.Value = fromServer.Value;
            this.DateCreatedUtc = fromServer.DateCreatedUtc;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/Advert.ts